import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/delivery.scss";

const shippingMethods = [
  {
    destination: "United States · all 50 states",
    service: "Tracked standard",
    cost: `$${siteConfig.commerce.shippingCost.toFixed(2)}`,
    transit: siteConfig.commerce.shippingEstimate,
  },
  {
    destination: "APO, FPO and PO boxes",
    service: "Tracked postal service",
    cost: `$${siteConfig.commerce.shippingCost.toFixed(2)}`,
    transit: "7–14 business days",
  },
];

function Delivery() {
  const { brandName, contact } = siteConfig;
  const supportHours = contact.supportHours || contact.hours;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="delivery">
      <header className="delivery__hero">
        <p>Help / Shipping</p>
        <h1>On its way.</h1>
        <span>Clear delivery details, from our door to yours.</span>
      </header>

      <section className="delivery__intro" aria-labelledby="shipping-heading">
        <p className="delivery__eyebrow">Shipping to the United States</p>
        <h2 id="shipping-heading">Packed with care. Tracked all the way.</h2>
        <p>
          Orders are usually prepared within 1–3 business days. As soon as your
          {` ${brandName} `}parcel leaves our warehouse, we will email a tracking
          link so you can follow the journey.
        </p>
      </section>

      <section className="delivery__rates" aria-labelledby="rates-heading">
        <div className="delivery__rates-heading">
          <p className="delivery__eyebrow">Delivery rates</p>
          <h2 id="rates-heading">Shipping at a glance.</h2>
        </div>
        <div className="delivery__table-wrap">
          <table>
            <caption className="delivery__sr-only">United States shipping rates</caption>
            <thead>
              <tr>
                <th scope="col">Destination</th>
                <th scope="col">Service</th>
                <th scope="col">Cost</th>
                <th scope="col">Estimated transit</th>
              </tr>
            </thead>
            <tbody>
              {shippingMethods.map((method) => (
                <tr key={method.destination}>
                  <td data-label="Destination">{method.destination}</td>
                  <td data-label="Service">{method.service}</td>
                  <td data-label="Cost">{method.cost}</td>
                  <td data-label="Estimated transit">{method.transit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="delivery__rate-note">
          Transit estimates begin after dispatch and exclude weekends, holidays
          and customs delays. The final rate and delivery estimate are confirmed
          during checkout.
        </p>
      </section>

      <section className="delivery__facts" aria-label="More shipping information">
        <article>
          <span>01</span>
          <h3>Tracking</h3>
          <p>
            Tracking may take up to 24 hours to update after the dispatch email.
            Check the carrier link again on the next business day.
          </p>
        </article>
        <article>
          <span>02</span>
          <h3>Taxes &amp; duties</h3>
          <p>
            Any charges shown at checkout are included in your order total.
            Carrier or customs fees not collected at checkout remain the
            recipient’s responsibility.
          </p>
        </article>
        <article>
          <span>03</span>
          <h3>Delivery issues</h3>
          <p>
            If tracking has not moved for five business days or the parcel is
            marked delivered but missing, contact us with your order number.
          </p>
        </article>
      </section>

      <section className="delivery__support">
        <div>
          <p className="delivery__eyebrow">Still waiting?</p>
          <h2>Let’s find your order.</h2>
        </div>
        <div>
          <p>
            Email <a href={`mailto:${contact.email}`}>{contact.email}</a> or send
            us a note through the contact form. We are available {supportHours}.
          </p>
          <div className="delivery__actions">
            <Link to="/contact" onClick={toTop}>Contact us</Link>
            <Link to="/returns" onClick={toTop}>Returns information</Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Delivery;
